import { Colors } from '@app/config/colors';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import React, { ChangeEvent, forwardRef, Ref, useImperativeHandle, useRef, useState } from 'react';

type DialogButton = {
  text: string;
  onClick?: () => void;
};

type DialogOptions = {
  title: string;
  message: string;
  radios: RadioProps[];
};

type RadioProps = {
  label: string;
  value: string;
};

type Props = {};

export type DialogChooseOptionsRefAttrs = {
  // alert: (options: DialogOptions) => void;
  choose: (options: DialogOptions) => Promise<RadioProps | null>;
};

type ResolverFunction = (value: RadioProps | null) => void;

function DialogWithRadioGroup(_: Props, ref: Ref<DialogChooseOptionsRefAttrs>) {
  const { primaryColor } = useRestaurantContext();

  const [dialogOptions, setDialogOptions] = useState<DialogOptions | null>(null);
  const [selectedRadio, setSelectedRadio] = useState<RadioProps | null>(null);

  const choosePromiseResolver = useRef<ResolverFunction | null>(null);

  function handleChoose(options: DialogOptions): Promise<RadioProps | null> {
    setDialogOptions(options);
    return new Promise<RadioProps | null>((resolve) => {
      choosePromiseResolver.current = resolve;
    });
  }

  useImperativeHandle(ref, () => {
    return {
      choose: handleChoose,
    };
  });

  function handleOnClose() {
    choosePromiseResolver.current && choosePromiseResolver.current(null);
    choosePromiseResolver.current = null;
    setDialogOptions(null);
  }

  function handleOnChangeRadioGroup(event: ChangeEvent<HTMLInputElement>) {
    console.log(event.target.value);
    const radio = dialogOptions?.radios.find((radio) => radio.value === event.target.value) ?? null;
    setSelectedRadio(radio);
  }

  function handlePositiveButtonClick() {
    choosePromiseResolver.current && choosePromiseResolver.current(selectedRadio);
    choosePromiseResolver.current = null;
    setDialogOptions(null);
  }

  return (
    <Dialog open={Boolean(dialogOptions)} onClose={handleOnClose}>
      <DialogTitle>{dialogOptions?.title ?? ''}</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogOptions?.message ?? ''}</DialogContentText>
        <RadioGroup value={selectedRadio?.value ?? null} onChange={handleOnChangeRadioGroup}>
          {dialogOptions?.radios.map((radio) => {
            return (
              <FormControlLabel
                value={radio.value}
                control={<Radio style={{ color: primaryColor || Colors.DefaultPrimaryColor }} />}
                label={radio.label}
              />
            );
          })}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        {/* {shouldUseOkDefaultAction && ( */}
        {/* <Button onClick={() => handleButtonClick({ text: 'OK', onClick: () => setAlertOptions(null) })}>OK</Button> */}
        {/* <Button onClick={() => handleButtonClick({ text: 'OK', onClick: () => setAlertOptions(null) })}>OK</Button> */}
        <Button onClick={handleOnClose}>Cancelar</Button>
        <Button onClick={handlePositiveButtonClick} disabled={selectedRadio === null}>
          Confirmar
        </Button>

        {/* )} */}
        {/* {(alertOptions?.buttons?.length ?? 0) > 0 && (
          <>
            {alertOptions?.buttons?.map((button, index) => {
              return (
                <Button key={String(index)} onClick={() => handleButtonClick(button)}>
                  {button.text}
                </Button>
              );
            })}
          </>
        )} */}
      </DialogActions>
    </Dialog>
  );
}

export default forwardRef<DialogChooseOptionsRefAttrs, Props>(DialogWithRadioGroup);
